<script setup lang="ts">
interface Props {
  modelValue?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const handleToggle = () => {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue)
  }
}

const toggleClasses = () => {
  const baseClasses = 'relative inline-flex h-6 w-11 items-center rounded-full transition-colors'
  const enabledClasses = props.modelValue ? 'bg-primary-500' : 'bg-gray-200'
  const disabledClasses = props.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
  return `${baseClasses} ${enabledClasses} ${disabledClasses}`
}

const thumbClasses = () => {
  const baseClasses = 'inline-block h-4 w-4 transform rounded-full bg-white transition-transform'
  const positionClasses = props.modelValue ? 'translate-x-6' : 'translate-x-1'
  return `${baseClasses} ${positionClasses}`
}
</script>

<template>
  <button type="button" :class="toggleClasses()" :disabled="disabled" @click="handleToggle">
    <span :class="thumbClasses()" />
  </button>
</template>
